// careerPage/innovatePage.tsx
import * as React from 'react';
import { FunctionComponent } from 'react';
import VerticalContainer from '../common/VerticalContainer';
import { useResponsive } from '../../contexts/ResponsiveContext';
import PageContainer from '../productPage/tableComponents/PageContainer';
import { Box, Button, SxProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AboutCareersMainTabContent } from '../../graphql/pimcore/modules/siteContent/types/AboutCareersContent';
import { useLocale } from '../../contexts/LocaleProvider';

const typographyStyle = {
    fontFamily: 'Poppins',
    fontSize: '1rem',
    lineHeight: '20px',
    fontWeight: 400,
};

const titleTypographyStyle = {
    fontFamily: 'Poppins',
    fontSize: '1rem',
    lineHeight: '100%',
    fontWeight: 600,
    paddingTop: '2rem', // 設定統一的間距
    paddingBottom: '5px',
};

const buttonProps: SxProps = {
    padding: '4px 4px 4px 11px', // 按钮的内边距
    gap: '10px', // 按钮中元素的间距
    width: '210px',
    height: '44px',
    backgroundColor: '#E5673E',
    borderRadius: '5px',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '36px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    transition: 'none',
    color: 'white',
    '&:hover': {
        background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
    },
};

const widthMap: Record<string, string> = {
    'zh-cn': '170px',
    'zh-tw': '170px',
    en: '215px',
    de: '215px',
    ja: '215px',
};

interface CareerInnovatePageProps {
    cmsContent: AboutCareersMainTabContent;
}
const InnovatePage: FunctionComponent<CareerInnovatePageProps> = ({ cmsContent }) => {
    const { locale, messages } = useLocale();

    const { isMaxScreen, isScreenXxl, isScreenXl, isScreenLg, isScreenMd, isScreenSm, isScreenXs } =
        useResponsive();

    const picHeight = (() => {
        if (isMaxScreen) return '495px';
        if (isScreenXxl) return '483px';
        if (isScreenXl) return '495px';
        if (isScreenLg) return '714px';
        if (isScreenMd) return '533px';
        if (isScreenSm) return '349px';
        // 預設或 isScreenXs：
        return '224px';
    })();

    const width = (() => {
        if (isMaxScreen) return '1185px';
        if (isScreenXxl) return '1185px';
        if (isScreenXl) return '1125px';
        if (isScreenLg) return '885px';
        if (isScreenMd) return '650px';
        if (isScreenSm) return '422px';
        // 預設或 isScreenXs：
        return '320px';
    })();

    const navigate = useNavigate();

    // const handleClick = () => {
    //     navigate(`/About/Careers/SearchJobs`);
    // };

    // https://www.wrike.com/open.htm?id=1712279942
    const handleClick = () => {
        window.open('https://www.linkedin.com/company/yageogroup/jobs/', '_blank');
    };

    const maskUrl = '/externalLink.svg';

    const searchJobsButtonContent = (
        <>
            {cmsContent.searchJobsLink?.linkText ?? 'Search Jobs'}
            <span
                style={{
                    display: 'inline-block',
                    width: '1.5rem',
                    height: '1.5rem',
                    backgroundColor: 'white', // 白色填充
                    maskImage: `url(${maskUrl})`,
                    maskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    WebkitMaskImage: `url(${maskUrl})`,
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskSize: 'contain',
                    verticalAlign: 'middle',
                }}
            />
        </>
    );

    const dynamicButtonProps: SxProps = {
        ...buttonProps,
        width: widthMap[locale] ?? '210px',
    };

    const deskTop = (
        <VerticalContainer
            containerName={'Innovate'}
            sx={{
                padding: 0, // 確保沒有內間距
                margin: 0, // 確保沒有額外的 margin
                height: 'auto', // 高度由內部內容決定,
                backgroundColor: '#FFFFFF',
            }}
        >
            <PageContainer sx={{ paddingTop: '5rem', paddingBottom: '5rem' }} innerSx={{ width }}>
                {/*這是左邊文字區域*/}
                <Box sx={{ width: 640, height: 720 }} data-testid={'text-area'}>
                    <Box
                        sx={{
                            '& h3': {
                                ...titleTypographyStyle,
                            },
                            ...typographyStyle,
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: cmsContent.mainText.content }} />
                    </Box>
                    {/*<Typography sx={typographyStyle}>*/}
                    {/*    At YAGEO Group, we are a world leader in the electronic components industry,*/}
                    {/*    dedicated to innovation, quality, and solutions for our customers. We*/}
                    {/*    believe that our employees are our greatest asset, and we are always looking*/}
                    {/*    for talented, driven individuals to join our global team.*/}
                    {/*</Typography>*/}

                    {/*<Typography sx={titleTypographyStyle}>Global Presence</Typography>*/}

                    {/*<Typography sx={typographyStyle}>*/}
                    {/*    YAGEO Group has over 100 locations and operates across Asia, Europe, and the*/}
                    {/*    Americas, offering diverse opportunities and experiences. Join a company*/}
                    {/*    that is truly global in scope and reach.*/}
                    {/*</Typography>*/}

                    {/*<Typography sx={titleTypographyStyle}>Innovation and Excellence</Typography>*/}

                    {/*<Typography sx={typographyStyle}>*/}
                    {/*    We are at the forefront of technological advancements in the electronic*/}
                    {/*    components industry. Working with us means being part of a team that is*/}
                    {/*    pushing the boundaries of what’s possible. We are committed to technological*/}
                    {/*    innovation and excellence in everything we do. At YAGEO Group, you'll be*/}
                    {/*    part of a team that sets industry standards and leads with purpose.*/}
                    {/*</Typography>*/}

                    {/*<Typography sx={titleTypographyStyle}>Collaborative Environment</Typography>*/}

                    {/*<Typography sx={typographyStyle}>*/}
                    {/*    Our culture fosters teamwork and collaboration, encouraging employees to*/}
                    {/*    share ideas and develop new solutions together.*/}
                    {/*</Typography>*/}

                    {/*<Typography sx={titleTypographyStyle}>Professional Growth</Typography>*/}

                    {/*<Typography sx={typographyStyle}>*/}
                    {/*    We believe in continuous learning and development. We offer opportunities*/}
                    {/*    for professional growth through training programs, mentorship, and career*/}
                    {/*    advancement.*/}
                    {/*</Typography>*/}

                    {/*/!*This is special require from figma*!/*/}
                    {/*<Typography sx={{...titleTypographyStyle, fontWeight: 700}}>*/}
                    {/*    Competitive Benefits*/}
                    {/*</Typography>*/}

                    {/*<Typography sx={typographyStyle}>*/}
                    {/*    We provide a comprehensive benefits package, including health insurance,*/}
                    {/*    retirement plans, and paid time off to ensure our employees are well taken*/}
                    {/*    care of.*/}
                    {/*</Typography>*/}
                </Box>
                {/*這是右邊圖片區域*/}
                {/*在 Flexbox 布局中，flex: 1 是一個簡寫，它其實代表了下面三個屬性的組合：*/}
                {/*flex-grow: 1: 當容器中有剩餘空間時，這個元素可以擴展並填滿這部分空間。*/}
                {/*flex-shrink: 1: 當容器空間不足時，這個元素會相對縮小。*/}
                {/*flex-basis: 0%: 元素的初始基礎寬度設置為 0，讓空間分配完全依賴於 flex-grow 的值。*/}
                <VerticalContainer
                    containerName={'innovate_pic'}
                    sx={{ flex: 1, display: 'flex', flexDirection: 'column', paddingLeft: '1rem' }}
                >
                    {/* 讓圖片的父層 Box 撐滿剩餘空間 */}
                    <Box sx={{ flex: 1 }}>
                        <Box
                            data-testid={'img'}
                            component="img"
                            src={cmsContent.mainImage.imageUrl}
                            alt="careerImage"
                            sx={{
                                height: picHeight,
                                width: '100%',
                                objectFit: 'cover',
                                borderRadius: '10px',
                            }}
                        />
                        <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '1rem' }}>
                            <Button
                                variant="contained"
                                sx={dynamicButtonProps}
                                onClick={handleClick}
                            >
                                {searchJobsButtonContent}
                            </Button>
                        </Box>
                    </Box>
                </VerticalContainer>
            </PageContainer>
        </VerticalContainer>
    );

    const lg = (
        <VerticalContainer
            containerName={'Innovate'}
            sx={{
                padding: 0, // 確保沒有內間距
                margin: 0, // 確保沒有額外的 margin
                height: 'auto', // 高度由內部內容決定,
                backgroundColor: '#FFFFFF',
            }}
        >
            <PageContainer sx={{ paddingTop: '2rem', paddingBottom: '2rem' }} innerSx={{ width }}>
                <VerticalContainer>
                    <Box
                        data-testid={'img'}
                        component="img"
                        src={cmsContent.mainImage.imageUrl}
                        alt="careerImage"
                        sx={{
                            height: picHeight,
                            width: '100%',
                            objectFit: 'contain',
                            borderRadius: '10px',
                        }}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '1rem',
                            paddingBottom: '1rem',
                        }}
                    >
                        <Button variant="contained" sx={dynamicButtonProps} onClick={handleClick}>
                            {searchJobsButtonContent}
                        </Button>
                    </Box>

                    {/*這是左邊文字區域*/}
                    <Box
                        data-testid={'text-area'}
                        sx={{ paddingTop: '1rem', paddingBottom: '1rem' }}
                    >
                        <Typography sx={typographyStyle}>
                            At YAGEO Group, we are a world leader in the electronic components
                            industry, dedicated to innovation, quality, and solutions for our
                            customers. We believe that our employees are our greatest asset, and we
                            are always looking for talented, driven individuals to join our global
                            team.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Global Presence</Typography>

                        <Typography sx={typographyStyle}>
                            YAGEO Group has over 100 locations and operates across Asia, Europe, and
                            the Americas, offering diverse opportunities and experiences. Join a
                            company that is truly global in scope and reach.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Innovation and Excellence</Typography>

                        <Typography sx={typographyStyle}>
                            We are at the forefront of technological advancements in the electronic
                            components industry. Working with us means being part of a team that is
                            pushing the boundaries of what’s possible. We are committed to
                            technological innovation and excellence in everything we do. At YAGEO
                            Group, you&apos;ll be part of a team that sets industry standards and
                            leads with purpose.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Collaborative Environment</Typography>

                        <Typography sx={typographyStyle}>
                            Our culture fosters teamwork and collaboration, encouraging employees to
                            share ideas and develop new solutions together.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Professional Growth</Typography>

                        <Typography sx={typographyStyle}>
                            We believe in continuous learning and development. We offer
                            opportunities for professional growth through training programs,
                            mentorship, and career advancement.
                        </Typography>

                        {/*This is special require from figma*/}
                        <Typography sx={{ ...titleTypographyStyle, fontWeight: 700 }}>
                            Competitive Benefits
                        </Typography>

                        <Typography sx={typographyStyle}>
                            We provide a comprehensive benefits package, including health insurance,
                            retirement plans, and paid time off to ensure our employees are well
                            taken care of.
                        </Typography>
                    </Box>
                </VerticalContainer>
            </PageContainer>
        </VerticalContainer>
    );

    const md = (
        <VerticalContainer
            containerName={'Innovate'}
            sx={{
                padding: 0, // 確保沒有內間距
                margin: 0, // 確保沒有額外的 margin
                height: 'auto', // 高度由內部內容決定,
                backgroundColor: '#FFFFFF',
            }}
        >
            <PageContainer sx={{ paddingTop: '1rem', paddingBottom: '1rem' }} innerSx={{ width }}>
                <VerticalContainer>
                    <Box
                        data-testid={'img'}
                        component="img"
                        src={cmsContent.mainImage.imageUrl}
                        alt="careerImage"
                        sx={{
                            height: picHeight,
                            width: '100%',
                            objectFit: 'contain',
                            borderRadius: '10px',
                        }}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '1rem',
                            paddingBottom: '1rem',
                        }}
                    >
                        <Button variant="contained" sx={dynamicButtonProps} onClick={handleClick}>
                            {searchJobsButtonContent}
                        </Button>
                    </Box>

                    {/*這是左邊文字區域*/}
                    <Box
                        data-testid={'text-area'}
                        sx={{ paddingTop: '1rem', paddingBottom: '1rem' }}
                    >
                        <Typography sx={typographyStyle}>
                            At YAGEO Group, we are a world leader in the electronic components
                            industry, dedicated to innovation, quality, and solutions for our
                            customers. We believe that our employees are our greatest asset, and we
                            are always looking for talented, driven individuals to join our global
                            team.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Global Presence</Typography>

                        <Typography sx={typographyStyle}>
                            YAGEO Group has over 100 locations and operates across Asia, Europe, and
                            the Americas, offering diverse opportunities and experiences. Join a
                            company that is truly global in scope and reach.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Innovation and Excellence</Typography>

                        <Typography sx={typographyStyle}>
                            We are at the forefront of technological advancements in the electronic
                            components industry. Working with us means being part of a team that is
                            pushing the boundaries of what’s possible. We are committed to
                            technological innovation and excellence in everything we do. At YAGEO
                            Group, you&apos;ll be part of a team that sets industry standards and
                            leads with purpose.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Collaborative Environment</Typography>

                        <Typography sx={typographyStyle}>
                            Our culture fosters teamwork and collaboration, encouraging employees to
                            share ideas and develop new solutions together.
                        </Typography>

                        <Typography sx={titleTypographyStyle}>Professional Growth</Typography>

                        <Typography sx={typographyStyle}>
                            We believe in continuous learning and development. We offer
                            opportunities for professional growth through training programs,
                            mentorship, and career advancement.
                        </Typography>

                        {/*This is special require from figma*/}
                        <Typography sx={{ ...titleTypographyStyle, fontWeight: 700 }}>
                            Competitive Benefits
                        </Typography>

                        <Typography sx={typographyStyle}>
                            We provide a comprehensive benefits package, including health insurance,
                            retirement plans, and paid time off to ensure our employees are well
                            taken care of.
                        </Typography>
                    </Box>
                </VerticalContainer>
            </PageContainer>
        </VerticalContainer>
    );

    if (isScreenLg) {
        return lg;
    } else if (isScreenMd || isScreenSm || isScreenXs) {
        return md;
    } else {
        return deskTop;
    }
};

export default InnovatePage;
